<template>
  <div class="wrap-content wrap-guruImage wrap-bg f-tal">
    <div class="list-filter-wrap-box">
      <v-list-filter
        v-model="bindForms"
        :form-arr="formArr"
        :form-rules="formRules"
        :is-add-btn="false"
        form-item-position="row"
        class="list-filter bg-white"
        @changeFormBind="changeFormBind" />
    </div>
    <div class="wrap-main-content">
      <div class="mg-top15 f-df">
        <!-- 粉丝量级 -->
        <v-pie-chart
          :is-load="isLoading[1]"
          :pie-list="fanweightList"
          :tip-txt="titleTxt[1].tipTxt"
          id="fanweight-pie-chart"
          title="粉丝量级" />
        <!-- 达人圈层 -->
        <section class="mg-left15 pd15 bg-white flex-1">
          <v-title :tip-txt="titleTxt[2].tipTxt" title="达人圈层" class="f-pa chart-title-box" />
          <no-data v-if="isNodata[2] && !isLoading[2]" height="350" style="margin-top: 45px;" />
          <div
            v-show="!isNodata[2]"
            id="talent-circle-bar-chart"
            v-loading="isLoading[2]"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            class="chart-box talent-circle-bar-chart"
          ></div>
        </section>
      </div>
      <div class="mg-top15 f-df">
        <!-- 互动成本 -->
        <v-pie-chart
          :is-load="isLoading[3]"
          :pie-list="costList"
          :tip-txt="titleTxt[3].tipTxt"
          id="interaction-cost-pie-chart"
          title="互动成本" />
        <!-- 内容类型 -->
        <section class="mg-left15 pd15 bg-white flex-1">
          <v-title :tip-txt="titleTxt[4].tipTxt" title="内容类型" class="f-pa chart-title-box" />
          <no-data v-if="isNodata[4] && !isLoading[2]" height="350" style="margin-top: 45px;" />
          <div
            v-show="!isNodata[4]"
            id="content-type-bar-chart"
            v-loading="isLoading[4]"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            class="chart-box content-type-bar-chart pd-row15"
          ></div>
        </section>
      </div>
      <section class="regional-distribution-model bg-white mg-top15 pd15">
        <v-title :tip-txt="titleTxt[0].tipTxt" title="地域分布" />
        <v-map
          ref="$map"
          :is-load="isLoading[0]"
          :area-type="areaType"
          :province-list='provinceList'
          @areaChoose="areaChoose" />
      </section>
      <!--内容列表-->
      <section class="pd15 bg-white mg-top15">
        <v-title :tip-txt="titleTxt[5].tipTxt" title="达人排行" mg-btm="mg-btm20 f-jcsb">
          <div class="f-df f-ai pd-right15">
            <label>排序指标：</label>
            <!--排序指标-->
            <el-select
              v-model="pageObj.sortIndex"
              placeholder="请选择"
              style="width: 170px;"
              @change="getList()">
              <el-option
                v-for="(elem, i) in sortIndex"
                :key="i"
                :label="elem.name"
                :value="elem.id" />
            </el-select>
            <!--排序顺序-->
            <el-select
              v-model="pageObj.sortRule"
              placeholder="请选择"
              style="width: 100px;"
              class="mg-left10"
              @change="getList()">
              <el-option
                v-for="(elem, i) in sortRules"
                :key="i"
                :label="elem.name"
                :value="elem.id" />
            </el-select>
          </div>
        </v-title>
        <v-table-list
          :is-loading="isLoading[5]"
          :table-head="tableHead"
          :page-list="pageList"
          :current-page="pageObj.page"
          :page-size="pageObj.pageSize"
          :total-size="pageObj.totalSize"
          :is-show-selection="false"
          :is-table-operation-btn="false"
          class="bg-white pd-row15"
          @sizeChange="sizeChange"
          @currentChange="currentChange" />
      </section>
    </div>
  </div>
</template>

<script>
import pageConfig from './page.config.js'
import noData from '@/components/nodata.vue'
import vListFilter from '@/components/form-filter/index.vue'
import vTitle from '@/components/vTitle.vue'
import vTableList from '@/components/table-list.vue'
import vMap from '@/components/chart/map.vue'
import vPieChart from '@/components/chart/pie.vue'
import $filterCommon from '@/components/form-filter/index.js'
import mixin from '@/views/analysis/analysis.js'
import chartRender from '@/views/analysis/chartRender.js'
import {
  getAreaTrend,
  getInteractPie,
  getTypeColumnar,
  getSortLabel,
  getList,
  getListTotal
} from '@/api/analysis/guruImage.js'
export default {
  components: {
    noData,
    vListFilter,
    vTitle,
    vTableList,
    vMap,
    vPieChart
  },
  mixins: [mixin, chartRender],
  data() {
    return {
      isLoading: [false, false, false, false, false, false],
      isNodata: [false, false, false, false, false, false],
      titleTxt: pageConfig.titleTxt,
      bindForms: {},
      formArr: [],
      formRules: {},
      areaType: '1', // 1-省，2-城市
      provinceList: [],
      fanweightList: [], // 粉丝量级列表
      costList: [], // 互动成本
      tableHead: [], // 表头
      pageList: [], // 内容数据
      sortIndex: [],
      sortRules: pageConfig.sortRules,
      pageObj: {
        page: 1,
        pageSize: 10,
        totalSize: 0,
        sortIndex: '', // issue_date按发布时间排序，impl_date按实施时间排序
        sortRule: '1' // 1倒序，2升序
      }
    }
  },
  created() {
  },
  mounted() {
    // 内容列表
    this.tableHead = JSON.parse(JSON.stringify(pageConfig.tableHead))
    // 获取排序指标
    this.getSortLabel()
    // 页面初始化
    this.init()
  },
  methods: {
    init() {
      // 请求所有条件
      const filterAjaxList = JSON.parse(JSON.stringify(pageConfig.filterAjaxList))
      Promise.all(filterAjaxList.map(item => $filterCommon.getLabelCommon(item.method, item.url, item.param, item))).then(data => {
        const formArr = JSON.parse(JSON.stringify(pageConfig.filterForm))
        // 初始化所有筛选条件集合
        const filterObj = $filterCommon.filterChooseHandle(formArr, data)
        // 初始化当前选择的筛选条件
        const $storeFilter = this.$store.state.platParam
        this.bindForms = Object.assign(filterObj.filterChooseObj, $storeFilter)
        this.formArr = filterObj.filterList
        // 默认时间初始化，如果$store存在默认时间选择，优先选择，否则默认初始化的时间
        const timeChooseItem = this.formArr.find(item => item.id === ($storeFilter.timeType ? 'timeType' : 'dateMonth')) || {}
        // 页面统一请求初始化并且请求
        this.changeFormBind(this.bindForms, timeChooseItem, $storeFilter.timeType || this.bindForms[timeChooseItem.intValue])
        // const timeChooseItem = this.formArr.find(item => item.id === 'dateMonth') || {}
        // // 页面统一请求初始化并且请求
        // this.changeFormBind(this.bindForms, timeChooseItem, this.bindForms[timeChooseItem.intValue])
      })
    },
    // 页面各个模块总入口请求
    pageTotalAjax() {
      // 获取地图数据，绘制地图
      this.getMapData()
      // 粉丝量级
      this.getInteractPie(1, 'fanweight-pie-chart', 1, 'fanweightList')
      // 达人圈层
      this.getTypeColumnar('auth_circle', 2, 'talent-circle-bar-chart', [
        {
          name: '人数',
          type: 'bar',
          data: [],
          itemColor: '#326CFA',
          emphasisColor: '#326CFA',
          key: 'cnt'
        }
      ])
      // 互动成本
      this.getInteractPie(2, 'interaction-cost-pie-chart', 3, 'costList')
      // 内容类型
      this.getTypeColumnar('content_type', 4, 'content-type-bar-chart', [
        {
          name: '人数',
          type: 'bar',
          data: [],
          itemColor: '#FFC750',
          emphasisColor: '#FFC750',
          key: 'cnt'
        }
      ])
      // 获取产线分析数据
      this.refreshList()
    },
    // 获取地图数据
    getMapData(areaType) {
      this.$set(this.isLoading, 0, true)
      getAreaTrend(Object.assign(this.getParam(), {
        type: areaType || this.areaType
      })).then(res => {
        this.$set(this.isLoading, 0, false)
        // const data = JSON.parse(JSON.stringify(pageConfig.mapData))
        const data = res.data || []
        const result = data.filter(item => item.name)
        const sum = result.length ? result[0].cnt * 1 : 0
        result.forEach(item => {
          item.rate = (item.cnt / sum * 100).toFixed(2) + '%'
          item.value = item.cnt
        })
        this.provinceList = result
      })
    },
    // 城市选择
    areaChoose(type) {
      this.areaType = type
      this.getMapData(type)
    },
    // 粉丝量级 / 互动成本
    getInteractPie(type, id, indexIsLoad, pieKeyList) {
      this.$set(this.isLoading, indexIsLoad || 1, true)
      getInteractPie(Object.assign(this.getParam(), {
        type: type || 1
      })).then(res => {
        this.$set(this.isLoading, indexIsLoad || 1, false)
        const colorArr = ['#326CFA', '#FFC750', '#E98144', '#DEE3E5', '#2D29A7']
        const pieList = (res.data || []).map((item, index) => {
          return {
            name: item.name,
            color: colorArr[index % 5],
            sumKey: 'cnt',
            sum: item.cnt,
            unit: '人'
          }
        })
        this[pieKeyList] = pieList
        // this.pieRender(id, 'sum', seriesData, pieList)
      })
    },
    // 内容类型 / 达人圈层
    getTypeColumnar(type, indexIsLoad, id, seriesData) {
      this.$set(this.isLoading, indexIsLoad, true)
      this.$set(this.isNodata, indexIsLoad, false)
      getTypeColumnar(Object.assign(this.getParam(), {
        index: type || 'auth_circle'
      })).then(res => {
        this.$set(this.isLoading, indexIsLoad, false)
        // const dataList = JSON.parse(JSON.stringify(pageConfig.talentCircleList))
        const dataList = res.data || []
        if (!dataList.length) {
          this.$set(this.isNodata, indexIsLoad, true)
          return
        }
        // y轴对应series值
        this.barRender(id, 'name', seriesData, dataList, '人数', -35)
      })
    },
    // 获取排序指标
    getSortLabel() {
      getSortLabel().then(res => {
        this.sortIndex = $filterCommon.getDataHandle(res.data || [], 'labelName', 'name')
        this.pageObj.sortIndex = this.sortIndex.length ? this.sortIndex[0].id : ''
      })
    },
    // 获取内容列表
    getList(currentPage, pageSize) {
      this.$set(this.isLoading, 5, true)
      this.pageObj.page = currentPage || 1
      pageSize && (this.pageObj.pageSize = pageSize)
      this.pageList = []
      getList(Object.assign(this.getParam(), {
        startPageNum: this.pageObj.page,
        pageSize: this.pageObj.pageSize,
        sortItem: this.pageObj.sortIndex,
        isSortMax: this.pageObj.sortRule
      })).then(res => {
        this.$set(this.isLoading, 5, false)
        this.pageList = (res.data || []).map((item, index) => {
          item.$index = index + 1
          return item
        })
      })
    },
    // 获取产线分析数据总数
    getListTotal() {
      this.pageObj.totalSize = -1
      getListTotal(this.getParam()).then(res => {
        this.pageObj.totalSize = res.data || 0
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.wrap-guruImage{
  & .chart-title-box{
    z-index: 3;
  }
  & .chart-box{
    height: 100%;
  }
  & .fanweight-pie-chart,
  & .interaction-cost-pie-chart{
    height: 350px;
    min-width: 200px;
  }
  & .fanweight-box,
  & .interaction-cost-box{
    width: 35%;
    min-width: 400px;
    & .chart-legend-box{
      min-width: 150px;
    }
    & .icon-pie-legend{
      width: 6px;
      height: 6px;
      border-radius: 50%;
    }
  }
}
</style>
